export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    callback: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      width: window.innerWidth,
    }
  },

  mounted() {
    window.addEventListener('resize', this.setWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWidth)
  },

  methods: {
    setWidth() {
      this.width = window.innerWidth
      // used instead of this.$emit
      this.callback(this.width)
    },
  },
  render(createElement) {
    return createElement(this.tag, this.$scopedSlots.default({ width: this.width }))
  },
}



// WEBPACK FOOTER //
// ./src/components/BaseWindowWatcher.js